import { template as template_ced530d3dbc64725a8d25aa1cdcfd0c0 } from "@ember/template-compiler";
import SiteDocumentsSharedAutosaveMessage from 'client-portal/components/site/documents/shared/autosave-message';
import t from 'ember-intl/helpers/t';
export default template_ced530d3dbc64725a8d25aa1cdcfd0c0(`
  <header class="intake-header">
    <h1>{{t "site.pages.waitlistIntake"}}</h1>
    <div class="title-rule" aria-hidden="true"></div>

    {{#unless @isComplete}}
      <div class="autosave" data-test-autosave-displayed={{@isAutosaveDisplayed}}>
        <SiteDocumentsSharedAutosaveMessage
          @tagName=""
          @isDisplayed={{@isAutosaveDisplayed}}
          @autosaveTask={{@autosaveTask}}
        />
      </div>
    {{/unless}}
  </header>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
